import type { Theme, SxProps } from "@mui/material/styles";

/**
 * Shared Data Entry styles for all modules (Caster, EAF, LMF, Laboratory)
 * Converted from makeStyles to sx-based styling for MUI v6
 */
export const dataEntryStyles = (
  theme: Theme,
): Record<string, SxProps<Theme>> => ({
  buttons: {
    maxHeight: 36,
    height: 36,
  },
});
